import React from 'react';
import {useSelector} from 'react-redux';
import { MODES } from '../../app/classes/constants';

function CwPlayer(props) {

    const textToDisplay = useSelector((state) => state.settings.textToDisplay);
    const type = useSelector((state) => state.settings.type);

    const getDistanceFromTop = () => {
        try {
            return document.getElementById("divCwDisplay").offsetTop + 10;
        }
        catch (e){
            console.log('getDistanceFromTop', e);
            return 160;
        }
    };

    const style = {
        height: `calc(100vh - ${getDistanceFromTop()}px)`
    }

    if(type === MODES.RANDOM_GROUPS.id || type === MODES.TOP_WORDS.id) {
        return (
            <div id="divCwDisplay" style={style} className="flex mt-16 p-6 w-full rounded-md border-gray-600 bg-black text-yellow-400 text-7xl text-center border-4">
                <div className="m-auto">
                    {textToDisplay}
                </div>
            </div>
        );
    }
    else {
        return (
            <div id="divCwDisplay" style={style} className="flex mt-16 p-6 w-full rounded-md border-gray-600 bg-black text-yellow-400 text-9xl text-center border-4">
                <div className="m-auto">
                    {textToDisplay}
                </div>
            </div>
        );
    }
}

export default CwPlayer;